import React, { useEffect, useState } from 'react'
import { useDeleteSupplierInvoiceMutation, useSupplierListQuery, useSupplierProductsQuery, useUpdateRequisitionStatusMutation } from '../../Store/Apis/supplierApis';
import { useOutletsQuery } from '../../Store/Apis/outletApi';
import { useSelector } from 'react-redux';
import { isDropdownPermission, isPermissionGranted } from '../../Hooks/permissionsMiddleware';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { Modal } from 'react-bootstrap';

const AddEditStockRequisitions = ({ submit, data, cancel }) => {
    const user = useSelector((state) => state.auth.user);
    const navigate = useNavigate();
    const [sortFilter, setSortFilter] = useState({
        outletID: ''
    });
    const getOutletApi = useOutletsQuery();
    const getSuppliersApi = useSupplierListQuery({
        outletID: sortFilter.outletID
    })
    const supplierProductsApi = useSupplierProductsQuery({
        outletID: sortFilter.outletID
    })

    const [form, setForm] = useState({
        outletName: '',
        supplierName: '',
        requisitionDate: '',
        requisitionNumber: '',
        requisitionNote: '',
        products: [],
    });

    useEffect(() => {
        if (data) {
            setForm({
                id: data.invoiceId,
                outletName: data.outletID,
                supplierName: data.supplierID,
                requisitionDate: data.invoiceDate.split("T")[0],
                requisitionNumber: data.invoiceNumber,
                requisitionNote: data.invoiceNote,
                products: data.childRecords.length > 0 ? data.childRecords.map((product) => ({
                    productId: product.productId,
                    childId: product.childID,
                    productName: product.productName,
                    serviceTypeName: product.name,
                    quantity: product.quantity,
                    serviceTypeId: product.serviceTypeID,
                    backOrder: product.backOrder,
                    reOrder: product.reOrder,
                    currentOrderQuantity: product.currentOrderQuantity,
                    availableQuantity: product.availableQuantity,
                    brandName: product.brandName,
                    isSelected: true
                })) : [{
                    productId: '',
                    childId: '',
                    productName: '',
                    quantity: '',
                    serviceTypeId: ''
                }],
            });
        }
    }, [data]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setForm({ ...form, [name]: value });
    };

    const [deleteSupplierInvoice] = useDeleteSupplierInvoiceMutation()

    const handleCheckboxChange = (product) => {
        setForm((prevForm) => {
            const productIndex = prevForm.products.findIndex((p) => p.productId === product.productId);
    
            if (productIndex !== -1) {
                // If the product exists, toggle its selected state instead of removing it
                const updatedProducts = [...prevForm.products];
                updatedProducts[productIndex] = {
                    ...updatedProducts[productIndex],
                    isSelected: !updatedProducts[productIndex].isSelected, // Toggle selected state
                };
    
                return { ...prevForm, products: updatedProducts };
            } else {
                // If the product is not in the list, add it with isSelected set to true
                return {
                    ...prevForm,
                    products: [
                        ...prevForm.products,
                        { 
                            productId: product.productID, 
                            childId: product.id, 
                            quantity: 1, 
                            productName: product.productName,
                            serviceTypeId: product.serviceTypeID,
                            isSelected: true, // Mark as selected
                        }
                    ],
                };
            }
        });
    };
    
    const handleQuantityChange = (productId, value) => {
        setForm((prevForm) => ({
            ...prevForm,
            products: prevForm.products.map((p) =>
                p.productId === productId ? { ...p, quantity: value } : p
            ),
        }));
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();

        form.products.filter((elem)=>elem.isSelected === false).map((elem)=>{
            console.log(elem)
            deleteSupplierInvoice(elem.productId)
        })

        submit({
            ...form,
            products: form.products.filter((elem)=> elem.isSelected === true)
        });
    };
    const [rejectionModal, setRejectionModal] = useState({modal: false, note: ''})
    const [updateRequisitionStatus] = useUpdateRequisitionStatusMutation()
    const approveRejectReq = (status) => {
        const payload = {
            invoiceID: form.id,
            statusID: status
        };
    
        // If status is 3, include rejectionNote
        if (status === 3) {
            payload.rejectionNote = rejectionModal.note; // Replace with actual note input
        } else {
            payload.rejectionNote = ''
        }
    
        updateRequisitionStatus(payload)
            .then((res) => {
                if (res.data.status === 200) {
                    toast.success(res.data.message);
                    cancel('');
                } else {
                    toast.error('Something went wrong !!');
                }
            });
    };

    const isInvalidOrder = form.products.some((p) => {
        const product = supplierProductsApi?.data?.data.find((prod) => prod.productID === p.productId);
        return product && p.quantity <= product.backOrder;
    });


    const selectedProductIds = form.products.map(p => p.productId);
    const selectedProducts = form.products;
    const availableProducts = supplierProductsApi?.data?.data.filter(prod => !selectedProductIds.includes(prod.productID));
    const [showModal, setShowModal] = useState(false);
    const [selectedModalProducts, setSelectedModalProducts] = useState([]);
    const handleModalCheckboxChange = (product) => {
        setSelectedModalProducts((prevSelected) => {
            const exists = prevSelected.some((p) => p.productID === product.productID);
            return exists ? prevSelected.filter((p) => p.productID !== product.productID) : [...prevSelected, product];
        });
    };
    const addSelectedProducts = () => {
        setForm((prevForm) => ({
            ...prevForm,
            products: [
                ...prevForm.products, 
                ...selectedModalProducts.map(product => ({
                    productId: product.productID,
                    childId: product.id,
                    productName: product.productName,
                    serviceTypeName: product.categoryName,
                    quantity: 1,
                    brandName: product.brand, 
                    serviceTypeId: product.serviceTypeID,
                    backOrder: product.backOrder,
                    reOrder: product.reOrder,
                    currentOrderQuantity: product.currentOrderQuantity,
                    availableQuantity: product.quantity,
                    isSelected: true
                }))
            ]
        }));
    
        // Clear modal selections and close modal
        setSelectedModalProducts([]);
        setShowModal(false);
    };

    useEffect(() => {
        if(!isDropdownPermission(user.role_Id) && !data){
          setForm({
            ...form,
            outletName: user.outletID
          })
        }
    }, [])

    useEffect(() => {
        if (user.role !== 'superAdmin') {
            setSortFilter({
                outletID: user.outletID
            });
        }
    }, []);

    return (
        <>
            <form onSubmit={handleSubmit}>
                <div className="row mb-3">
                    <div className="col-md-6">
                        <label>Choose Outlet</label>
                        <select
                            className="form-select"
                            name="outletName"
                            value={form.outletName}
                            onChange={handleInputChange}
                            required
                            disabled={!getOutletApi.isSuccess || !isDropdownPermission(user.role_Id) || data?.requisitionStatus === 3 || data?.requisitionStatus === 2}
                        >
                            <option value="">Select Outlet</option>
                            {getOutletApi?.data?.data.map(outlet => (
                                <option key={outlet.outletId} value={outlet.outletId}>
                                    {outlet.outletName}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6">
                        <label>Choose Supplier</label>
                        <select
                            className="form-select"
                            name="supplierName"
                            value={form.supplierName}
                            onChange={handleInputChange}
                            required
                            disabled={!getSuppliersApi.isSuccess || data?.requisitionStatus === 3 || data?.requisitionStatus === 2}
                            
                        >
                            <option value="">Select Supplier</option>
                            {getSuppliersApi?.data?.data.map(supplier => (
                                <option key={supplier.id} value={supplier.id}>
                                    {supplier.companyName}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>

                <div className="row mb-3">
                    <div className="col-md-6">
                        <label>Requisition Date</label>
                        <input
                            type="date"
                            className="form-control"
                            name="requisitionDate"
                            value={form.requisitionDate}
                            onChange={handleInputChange}
                            required
                            disabled={data?.requisitionStatus === 3 || data?.requisitionStatus === 2}
                            min={!data && new Date().toISOString().split('T')[0]} 
                        />
                    </div>
                    {
                        data?.invoiceNumber && (
                            <div className="col-md-6">
                                <label>Requisition Number</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="requisitionNumber"
                                    value={form.requisitionNumber}
                                    readOnly
                                />
                            </div>
                        )
                    }
                </div>

                <div className="mb-3">
                    <label>Requisition Note</label>
                    <textarea
                        className="form-control"
                        name="requisitionNote"
                        value={form.requisitionNote}
                        onChange={handleInputChange}
                        disabled={data?.requisitionStatus === 3 || data?.requisitionStatus === 2}
                    />
                </div>

                {
                    data?.requisitionStatus === 3 && 
                    <p className='text-sm'>
                        <strong className='text-danger'>Rejection Note: </strong><br />
                        {data?.rejectionNote}
                    </p>
                }
        
                <div className="table-responsive">
                    <table className="table align-items-center mb-0">
                        <thead className="bg-light">
                            <tr>
                                <th className="text-uppercase text-secondary text-xs px-4"></th>
                                <th className="text-uppercase text-secondary text-xs px-4">Product Name</th>
                                <th className="text-uppercase text-secondary text-xs px-4">Brand</th>
                                <th className="text-uppercase text-secondary text-xs px-4">Price</th>
                                <th className="text-uppercase text-secondary text-xs px-4">Re-order Level</th>
                                <th className="text-uppercase text-secondary text-xs px-4">Backorder QTY</th>
                                <th className="text-uppercase text-secondary text-xs px-4">Requested QTY</th>
                                <th className="text-uppercase text-secondary text-xs px-4">Available QTY</th>
                                <th className="text-uppercase text-secondary text-xs px-4">Add Quantity</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                selectedProducts.length > 0 ?
                                selectedProducts?.map((prod, i) => {
                                    const selectedProduct = form.products.find((p) => p.productId === prod.productId)
                                    return (
                                        <tr key={i}>
                                            <td className="px-4">
                                                <span className="form-check">
                                                <input
                                                    type="checkbox"
                                                    className="form-check-input"
                                                    onChange={() => handleCheckboxChange(prod)}
                                                    checked={form.products.some((p) => p.productId === prod.productId && p.isSelected)}
                                                    disabled={data?.requisitionStatus === 3 || data?.requisitionStatus === 2 || prod?.currentOrderQuantity !== 0}
                                                />
                                                </span>
                                            </td>
                                            <td className="px-4">
                                                <span className="text-sm fw-bold d-block">
                                                    {`${prod.productName} [${prod.serviceTypeName}]`}
                                                </span>
                                            </td>
                                            <td className="px-4"><span className="text-sm d-block">{prod.brandName || 'N/A'}</span></td>
                                            <td className="px-4"><span className="text-sm d-block">R {prod.price || 0}</span></td>
                                            <td className="px-4"><span className="text-sm d-block">{prod.reOrder}</span></td>
                                            <td className="px-4"><span className="text-sm d-block">{prod.backOrder}</span></td>
                                            <td className="px-4"><span className="text-sm d-block">{prod.currentOrderQuantity}</span></td>
                                            <td className="px-4"><span className="text-sm d-block">{prod.availableQuantity}</span></td>
                                            <td className="px-4">
                                                <input
                                                    type="text"
                                                    className={`form-control ${selectedProduct?.quantity < prod.backOrder - prod.availableQuantity? 'border border-danger' : ''}`}
                                                    disabled={!selectedProduct || data?.requisitionStatus === 3 || data?.requisitionStatus === 2 }
                                                    value={selectedProduct?.quantity ?? ""}
                                                    onChange={(e) => handleQuantityChange(prod.productId, e.target.value)}
                                                />
                                                 {selectedProduct?.quantity <= prod.backOrder - prod.availableQuantity && (
                                                           <span className='text-xs text-danger'>
                                                                Value should be greater than {Number(prod.backOrder - prod.availableQuantity)}
                                                            </span>
                                                )}

                                            </td>
                                        </tr>
                                    );
                                }) : (
                                    <tr>
                                        <td colSpan={9} className='text-center text-sm py-5'>
                                            No Data found !!
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                </div>
                
                {
                    (data?.requisitionStatus === 1 || !data) && (
                        <div className='text-center mt-3'>
                            <button 
                                type="button" 
                                className="btn btn-secondary" 
                                onClick={() => setShowModal(true)}
                                disabled={!availableProducts}
                            >
                                Add More Items
                            </button>
                        </div>
                    )
                }                

<div className="d-flex justify-content-center mt-2 gap-2 border-top pt-4">
  {
    selectedProducts.length > 0 &&
    selectedProducts.map((prod, i) => {
      const selectedProduct = form.products.find((p) => p.productId === prod.productId);
      
      return (
        data?.requisitionStatus === 1 && (
          <React.Fragment key={i}>
            {
              isPermissionGranted(2002) && (
                <>
                  <button 
                    type="button" 
                    className="btn btn-danger bg-danger mr-2 mb-0" 
                    onClick={() => setRejectionModal({...rejectionModal, modal: true})}
                  >   
                    Reject
                  </button>
                  <button 
                    type="button" 
                    className="btn btn-success mb-0" 
                    onClick={() => approveRejectReq(2)} 
                    disabled={isInvalidOrder || selectedProduct?.quantity <= prod.backOrder - prod.availableQuantity}
                  >
                    Approve
                  </button>
                </>
              )
            }
            {
              isPermissionGranted(2005) && (
                <button 
                  type="submit" 
                  className="btn btn-primary mb-0" 
                  disabled={isInvalidOrder || selectedProduct?.quantity <= prod.backOrder - prod.availableQuantity}
                >
                  Update
                </button>
              )
            }
          </React.Fragment>
        )
      );
    })
  }
  {
    data?.requisitionStatus === 2 && isPermissionGranted(2003) && (
      <>
        <button className="btn btn-primary mb-0" onClick={() => approveRejectReq(4)}>
          Confirm Delivery
        </button>
      </>
    )
  }
  {
    !data && (
      <button type="submit" className="btn btn-primary mb-0" disabled={isInvalidOrder}>
        Submit
      </button>
    )
  }
</div>
            </form>

            <Modal 
                show={rejectionModal.modal} 
                onHide={() => setRejectionModal({modal: false})}
            >
                <Modal.Body className='p-4'>
                    <h5 className='mb-3'>Add Rejection Note</h5>
                    <textarea className='form-control' onChange={(e)=>setRejectionModal({...rejectionModal, note: e.target.value})}></textarea>                    
                    <div className='mt-3 text-center'>
                        <button type='button' className='bg-danger btn btn-danger mb-0 btn-sm mx-1' onClick={() => setRejectionModal({modal: false})}>
                            Close
                        </button>
                        <button type='button' className='btn btn-primary mb-0 btn-sm mx-1' onClick={() => approveRejectReq(3)}>
                            Submit
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={showModal} onHide={() => setShowModal(false)} size='lg'>
                <Modal.Body className='px-3'>
                    <h5 className='text-center mb-3'>Select Products</h5>
                    <div className="table-responsive">
                        <table className="table table-sm align-items-center mb-0">
                            <thead className="bg-light">
                                <tr>
                                    <th className="text-uppercase text-secondary text-xs px-2"></th>
                                    <th className="text-uppercase text-secondary text-xs px-2">Product Name</th>
                                    <th className="text-uppercase text-secondary text-xs px-2">Brand</th>
                                    <th className="text-uppercase text-secondary text-xs px-2">Price</th>
                                    <th className="text-uppercase text-secondary text-xs px-2">Re-order Level</th>
                                    <th className="text-uppercase text-secondary text-xs px-2">Backorder QTY</th>
                                    <th className="text-uppercase text-secondary text-xs px-2">Requested QTY</th>
                                    <th className="text-uppercase text-secondary text-xs px-2">Available QTY</th>
                                </tr>
                            </thead>
                            <tbody>
                                {availableProducts?.map(prod => (
                                    <tr key={prod.productID}>
                                        <td className="px-2">
                                            <span className="form-check">
                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                onChange={() => handleModalCheckboxChange(prod)}
                                                checked={selectedModalProducts.some((p) => p.productID === prod.productID)}
                                                disabled={prod?.currentOrderQuantity !== 0}
                                            />
                                            </span>
                                        </td>
                                        <td className="px-2" style={{width: '200px', whiteSpace: 'wrap'}}>
                                            <span className="text-xs fw-bold d-block">
                                                {`${prod.productName} [${prod.categoryName}]`}
                                            </span>
                                        </td>
                                        <td className="px-2"><span className="text-xs d-block">{prod.brand || 'N/A'}</span></td>
                                        <td className="px-2"><span className="text-xs d-block">R {prod.price || 0}</span></td>
                                        <td className="px-2"><span className="text-xs d-block">{prod.reOrder}</span></td>
                                        <td className="px-2"><span className="text-xs d-block">{prod.backOrder}</span></td>
                                        <td className="px-2"><span className="text-xs d-block">{prod.currentOrderQuantity}</span></td>
                                        <td className="px-2"><span className="text-xs d-block">{prod.quantity}</span></td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div className='text-center'>
                        <button type="button" className="btn btn-primary mb-0 mt-2" onClick={addSelectedProducts}>
                            Add Products
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}


export default AddEditStockRequisitions